export default `---
slug: luxembourg
country: Luxembourg
countryCode: LUX
continent: Europe
year: 2024
title: "A Detour Worth Taking"
description: "A work trip to deliver a banking course, Silvia tagging along, and a city that turned out to be much more interesting than either of us expected."
thumbnail: /images/travels/LUX/lux_1.jpg
relatedLinks: []
---

I went to Luxembourg for work. That's the full context. My company needed someone to deliver a health check and troubleshooting course to BIL — Banque Internationale à Luxembourg — and that someone was me. Silvia was available to tag along, and since the company was covering flights and hotel, we turned it into a couple of evenings of actual sightseeing.

Let me be honest: if it weren't for the work trip, Luxembourg City would never have made my list. It doesn't strike me as an obvious tourist destination. It's small. It's quiet. It's the kind of place you fly over on the way to somewhere else.

And I was completely wrong about it.

## The Gorge Nobody Tells You About

I was expecting flat. Luxembourg is a small, landlocked country in the heart of western Europe — I had some vague mental image of neat streets and bank headquarters. What I did not expect was a <b>city built on the edge of a dramatic rocky gorge</b>, with tall bridges spanning a deep valley carved by the Alzette river below.

The way the city develops across both sides of that cleft, with the old fortification walls plunging straight down into the green park at the bottom, and those stone viaducts connecting everything above — it's genuinely striking. Beautiful, even. I kept stopping and looking down just to check it was real.

![Luxembourg City](/images/travels/LUX/lux_1.jpg "Sexy Topi")

The city itself is small and very clean — pristine, almost to a fault — with a handful of streets lined with buildings that are a couple of centuries old, all in that characteristic northern European stone style. It's not the kind of city where you need three days and a guidebook. <i>Two evenings and comfortable shoes will do the job.</i>

## Grand in Name, Compact in Practice

The Grand Duchy of Luxembourg has always struck me as slightly absurd in the best possible way. It's one of the smallest countries in the world, one of the richest per capita, home to more bank accounts than people, and has more castles per square kilometre than you'd expect from a place you could walk across in an afternoon.

We did what any sensible tourist does: walked around, found a spot with a view of the gorge, ate well, and called it a successful evening. No museums, no guided tours, no real plan. Just a city that rewarded a bit of wandering.

![Luxembourg streets](/images/travels/LUX/lux_2.jpg)

## The Tax-Efficient Exit

I will not pretend the best part of leaving Luxembourg wasn't also the most practical part.

Luxembourg is notoriously expensive for everything except alcohol, tobacco, and fuel — all of which are taxed considerably lower than in France, Belgium, or Germany. The country has essentially become a destination for people from neighbouring nations who stop there specifically to fill their tanks and load up on cigarettes.

We joined them. Just before crossing the border, we pulled into a petrol station, filled the tank to the brim, and came home with a collection of items we did not strictly need but paid almost nothing for.

<i>The efficiency of it all felt almost Swiss.</i>

Luxembourg: a small country, a genuine surprise, and a very good petrol stop.
`;
